import { captureError } from '../../pages/captureError';
import { track } from '../../tracking';
import { PARCHI_REQUEST_ABHA } from '../constants';
import fetchWithRefresh from '../fetchWithRefresh';

interface Response {
    success: boolean;
    error?: string;
}

const requestAbhaFromPt = (ptId: string): Promise<Partial<Response>> => {
    return fetchWithRefresh(PARCHI_REQUEST_ABHA(ptId), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res.json());
};

export const requestAbhaCreation = (
    ptId: string,
    onSuccess?: () => void,
    onError?: () => void,
    onComplete?: () => void,
): void => {
    track('REQUEST_ABHA_TRIGGERED');

    requestAbhaFromPt(ptId)
        .then((res) => {
            if (res.success) {
                track('REQUEST_ABHA_SUCCESS');
                onSuccess && onSuccess();
            } else {
                throw new Error(res.error);
            }
        })
        .catch((e) => {
            track('REQUEST_ABHA_ERROR');
            captureError(e);
            onError && onError();
        })
        .finally(() => {
            onComplete && onComplete();
        });
};
